import React, { useState, useEffect } from 'react';
import { TextBox, SelectBox, List } from 'devextreme-react';
import * as Fnctn from '../../contexts/GenericFunctions'
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';
import notify from 'devextreme/ui/notify';

interface PropsCantidad {
    CantidadVal: any;
    handleTextChanged: (e: any, Textbox: string) => void;
}

const Cantidad: React.FC<PropsCantidad> = ({ CantidadVal, handleTextChanged }) => {
    const [cantidad, setCantidad] = useState<any>();

    useEffect(() => {
        if (cantidad !== CantidadVal) {
            setCantidad(CantidadVal);
        }
    }, [CantidadVal]);

    const handleSelectionChange = (e: any, Textbox: string = "") => {
        handleTextChanged(e, Textbox);
    };

    return (
        <TextBox
            label='Cantidad'
            value={cantidad}
            onValueChanged={(e:any) => handleSelectionChange(e, "Cantidad")}
            width={"10%"}
            style={{ margin: '0px 20px 0px 0px' }}
        ></TextBox>
    );
};

interface PropsTiempo {
    TiempoVal: any;
    onValueChangedList: (e: any, tiempo: string) => void;
}

const Tiempo: React.FC<PropsTiempo> = ({ TiempoVal, onValueChangedList }) => {
    const [tiempo, setTiempo] = useState<any>();

    useEffect(() => {
        if (tiempo !== TiempoVal) {
            setTiempo(TiempoVal);
        }
    }, [TiempoVal]);

    const handleSelectionChange = (e: any) => {
        onValueChangedList(e, "Tiempo");
    };

    const ItemsTiempo = [
        { Codigo: "D", Nombre: 'Días' },
        { Codigo: "S", Nombre: 'Semanas' },
        { Codigo: "A", Nombre: 'Años' }
    ];

    return (
        <SelectBox
            items={ItemsTiempo}
            displayExpr="Nombre"
            valueExpr="Codigo"
            label='Tiempo'
            onSelectionChanged={handleSelectionChange}
            width={"30%"}
            style={{ margin: '0px 20px 0px 0px' }}
            value={tiempo}
        />
    );
};

interface PropsSecuencia {
    SecuenciaVal: any;
    onValueChangedList: (e: any, secuencia: string) => void;
}

const Secuencia: React.FC<PropsSecuencia> = ({ SecuenciaVal, onValueChangedList }) => {
    const [secuencia, setSecuencia] = useState<any>();

    useEffect(() => {
        if (secuencia !== SecuenciaVal) {
            setSecuencia(SecuenciaVal);
        }
    }, [SecuenciaVal]);

    const handleSelectionChange = (e: any) => {
        onValueChangedList(e, "Secuencia");
    };

    const ItemsSecuencia = [
        { Codigo: "before", Nombre: 'Antes' },
        { Codigo: "after", Nombre: 'Después' }
    ];

    return (
        <SelectBox
            value={secuencia}
            items={ItemsSecuencia}
            displayExpr="Nombre"
            valueExpr="Codigo"
            label='Secuencia'
            onSelectionChanged={(e) => handleSelectionChange(e)}
            width={"30%"}
        />
    );
};

interface PropsNotificaciones {
    NotificacionesVal: any;
    onValueChangedList: (e: any, notifiacion: string) => void;
}

const Notificaciones: React.FC<PropsNotificaciones> = ({ NotificacionesVal, onValueChangedList }) => {
    const [notificaciones, setNotificaciones] = useState<any>();

useEffect(() => {
    if (notificaciones !== NotificacionesVal) {
        setNotificaciones(NotificacionesVal);
    }
}, [NotificacionesVal]);

const handleSelectionChange = (e: any) => {
    onValueChangedList(e, "Notificacion");
};

const ItemsNotificacion = [
    { Codigo: false, Nombre: 'No notificar' },
    { Codigo: true, Nombre: 'Notificar' }
  ];

    return (
        <SelectBox
    value={notificaciones}
    items={ItemsNotificacion}
    displayExpr="Nombre"
    valueExpr="Codigo"
    label='Notificación'
    onSelectionChanged={(e) => handleSelectionChange(e)}
    width={"30%"}
/>
    );
};

interface PropsAudiencia {
    props: any,
    selectedItems: any
    getIds: (e: any, list: string) => void;
}

const Audiencia: React.FC<PropsAudiencia> = ({ props, selectedItems, getIds }) => {
    const [dtArea, setDtArea] = useState<any>([]);
    const [dtEmpresa, setDtEmpresa] = useState<any>([]);
    const [dtSucursal, setDtSucursal] = useState<any>([]);
    const [dataSource, setdataSource] = useState<any>([]);
    const [list, setlist] = useState<any>();
    const [selectedIds, setSelectedIds] = useState<any>([]);
    const [areas, setAreas] = useState<any>([]);
    const [branches, setBranches] = useState<any>([]);
    const [companies, setCompanies] = useState<any>([]);

    let GetAudiencias = async () => {
        try {
            let dtresponseArea = await Fnctn.postData(`/catalogs/areas`, "GET", {});
            dtresponseArea = await dtresponseArea.json();
            setDtArea(dtresponseArea);
            let dtresponseSucursal = await Fnctn.postData(`/catalogs/branches_list`, 'POST', { "cvecia": "007" });
            dtresponseSucursal = await dtresponseSucursal.json()
            setDtSucursal(dtresponseSucursal);
            let dtresponseEmpresa = await Fnctn.postData(`/catalogs/companies`, 'GET', {});
            dtresponseEmpresa = await dtresponseEmpresa.json()
            setDtEmpresa(dtresponseEmpresa);
            // halcoloaderRemove();
            return {
                areas: dtresponseArea,
                sucursal: dtresponseSucursal,
                empresa: dtresponseEmpresa
            }
            // itemRenderAccordio(listTypeA)
        }
        catch (error) {
            halcoloaderRemove();
            notify(error, "error");
        }
    };

    const handleSelectionChanged = (e: any, list: string) => {
        const selectedItems = e.component.option('selectedItems');
        const selectedIds: any = [];

        selectedItems.forEach((item: any) => {
            selectedIds.push(item._id);
        });

        if (list === "areas") {
            setAreas(selectedIds);
            setSelectedIds(selectedIds);
        } else if (list === "branches") {
            setBranches(selectedIds);
            setSelectedIds(selectedIds);
        } else if (list === "companies") {
            setCompanies(selectedIds);
            setSelectedIds(selectedIds);
        }

        getIds(selectedIds, list);
    };

    const itemRenderAccordio = async (itemData: any) => {
        let audiencia: any = await GetAudiencias();

        if (itemData.Codigo === "areas") {
            setdataSource(audiencia.areas.data);
            setlist("areas");
            setSelectedIds(selectedItems.areas && selectedItems.areas.length > 0 ? selectedItems.areas : []);
        }
        else if (itemData.Codigo === "branches") {
            setdataSource(audiencia.sucursal.data);
            setlist("branches");
            setSelectedIds(selectedItems.branches && selectedItems.branches.length > 0 ? selectedItems.branches : []);
        }
        else if (itemData.Codigo === "companies") {
            let companiesData = audiencia.empresa.data.filter((item: any) => item.cvecia && item.cvecia.includes("0"));
            setdataSource(companiesData);
            setlist("companies");
            setSelectedIds(selectedItems.companies && selectedItems.companies.length > 0 ? selectedItems.companies : []);
        }
    };

    useEffect(() => {
        if (props.Codigo === "areas") {
            setSelectedIds(selectedItems.areas && selectedItems.areas.length > 0 ? selectedItems.areas : []);
        }
        else if (props.Codigo === "branches") {
            setSelectedIds(selectedItems.branches && selectedItems.branches.length > 0 ? selectedItems.branches : []);
        }
        else if (props.Codigo === "companies") {
            setSelectedIds(selectedItems.companies && selectedItems.companies.length > 0 ? selectedItems.companies : []);
        }
        itemRenderAccordio(props);
    }, [props.Codigo, selectedItems]);

    return (
        <List
            dataSource={dataSource}
            height={400}
            showSelectionControls={true}
            selectionMode={"multiple"}
            selectByClick={true}
            displayExpr={"name"}
            keyExpr={"_id"}
            onSelectionChanged={(e) => handleSelectionChanged(e, list)}
            selectedItemKeys={selectedIds}
        ></List>
    );
};

export { Cantidad };
export { Tiempo };
export { Secuencia };
export { Notificaciones };
export { Audiencia };
